import { __assign, __extends } from "tslib";
import React from "react";
import { View } from "react-native";
import PropTypes from "prop-types";
import PnmacText from "../Typography/PnmacText";
import styles from "./PnmacLoanSwitcher.styles.js";
import { textStyle } from "../v2/theme";
var PnmacLoanSwitcherTabs = /** @class */function (_super) {
  __extends(PnmacLoanSwitcherTabs, _super);
  function PnmacLoanSwitcherTabs() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      openModal: false
    };
    return _this;
  }
  PnmacLoanSwitcherTabs.prototype.render = function () {
    var _a = this.props,
      onValueChange = _a.onValueChange,
      selectedTabStyles = _a.selectedTabStyles,
      rowContainerStyles = _a.rowContainerStyles,
      defaultTabStyles = _a.defaultTabStyles,
      loans = _a.loans,
      selectedValue = _a.selectedValue,
      defaultTextColor = _a.defaultTextColor;
    return /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({}, styles.rowContainerStyles), rowContainerStyles)
    }, loans.map(function (d, i) {
      var propertyAddressLine1 = (d.customerProperty.find(function (s) {
        return s.loanId == d.loanId;
      }) || {
        propertyAddressLine1: ""
      }).propertyAddressLine1;
      if (selectedValue == d.loanId) {
        return /*#__PURE__*/React.createElement(View, {
          key: i,
          style: __assign(__assign({}, styles.selectedTabStyles), selectedTabStyles)
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: textStyle.loanSelector
        }, propertyAddressLine1));
      }
      return /*#__PURE__*/React.createElement(View, {
        key: i,
        onClick: function () {
          return onValueChange(d.loanId);
        },
        style: __assign(__assign({}, styles.defaultTabStyles), defaultTabStyles)
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign(__assign({}, textStyle.loanSelector), defaultTextColor)
      }, propertyAddressLine1));
    }));
  };
  return PnmacLoanSwitcherTabs;
}(React.Component);
PnmacLoanSwitcherTabs.propTypes = {
  loanIds: PropTypes.array,
  onValueChange: PropTypes.func,
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  address: PropTypes.string,
  selectedTabStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
  rowContainerStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
  defaultTabStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
  loans: PropTypes.array
};
export default PnmacLoanSwitcherTabs;